import { Option } from '@workwave-tidal/form-ui/RadioGroup'

import * as OrderTexts from '../../../../../../intl'
import { form } from '../../../formState'
import { Props } from '../typings'

const getOrderTypeValues = (
  initialValue: uui.domain.client.rm.OrderIdentifier,
): Option<string>[] => [
  {
    label: OrderTexts.getOrderTypePickupText(),
    value: 'p',
    disabled: initialValue === 'pd',
  },
  {
    label: OrderTexts.getOrderTypeDeliveryText(),
    value: 'd',
    disabled: initialValue === 'pd',
  },
  {
    label: OrderTexts.getOrderTypeServiceText(),
    value: 's',
    disabled: initialValue === 'pd',
  },
  {
    label: OrderTexts.getOrderTypePickupDeliveryText(),
    value: 'pd',
  },
]

export function OrderType(props: Props) {
  const orderTypeValues: Option<string>[] = getOrderTypeValues(props.initialValues.type)

  const {
    disabledFields = [],
    initialValues: { type },
  } = props

  const disabled = disabledFields.includes('type')

  const info = type === 'pd' ? OrderTexts.getDeletePairedFirstMessage() : undefined

  return (
    <form.RadioGroup
      name="type"
      label={OrderTexts.getFieldLabelOrderTypeText()}
      testId="type"
      options={orderTypeValues}
      disabled={disabled}
      helperText={info}
    />
  )
}
